import "@/App.css";
import { Loader2 } from "lucide-react";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import Login from "@/pages/Login";
import TherapistDashboard from "@/pages/TherapistDashboard";
import ClinicAdminDashboard from "@/pages/ClinicAdminDashboard";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";

const Main = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-brand-teal" />
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <div className="pt-10 min-h-screen">
      {user.role === "super_admin" && <SuperAdminDashboard />}
      {user.role === "clinic_admin" && <ClinicAdminDashboard />}
      {user.role === "therapist" && <TherapistDashboard />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <AuthProvider>
        <DisclaimerBanner />
        <Main />
      </AuthProvider>
    </div>
  );
}

export default App;
